import { render, staticRenderFns } from "./selectMention.vue?vue&type=template&id=d4a50ac8&"
import script from "./selectMention.vue?vue&type=script&lang=js&"
export * from "./selectMention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports